export type MultilingualValue = Record<string, string>;

export function isMultilingualValue(value: unknown): value is MultilingualValue {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const entries = Object.entries(value as Record<string, unknown>);
  return entries.length > 0 && entries.every(([, v]) => typeof v === 'string');
}

export function resolveMultilingualValue(
  value: unknown,
  locale: string,
  fallbackLocale?: string,
): string {
  if (typeof value === 'string') return value;
  if (!isMultilingualValue(value)) return '';
  return (
    value[locale] ??
    (fallbackLocale ? value[fallbackLocale] : undefined) ??
    Object.values(value)[0] ??
    ''
  );
}

/**
 * Studio page/category autocomplete used to save selection keys as `{locale}-{path}` (e.g. `hu-/products/x`).
 * Normalizes those to a plain path for links.
 */
export function stripLegacyLocalePrefixFromHref(href: string): string {
  return href.replace(/^[a-z]{2}-(?=\/)/i, '');
}
